import React, { useEffect, useState } from 'react';
import Promotion1 from "../../assets/images/banners/promotion-banner-1.png";
import Promotion2 from "../../assets/images/banners/promotion-banner-2.png";
import Sports from "../../assets/images/banners/Sports.webp";
import RG from "../../assets/images/banners/royal_gaming.webp";
import Ezugi from "../../assets/images/banners/Ezugi.webp";
import Evolution from "../../assets/images/banners/Evolution.webp";
import VSports from "../../assets/images/banners/virtual_sports.webp";
import "./PromotionSidebar.scss";
import { NavLink, useHistory } from 'react-router-dom';
import { AuthResponse } from '../../models/api/AuthResponse';
import SVLS_API from '../../svls-api';
import { BRAND_DOMAIN } from '../../constants/Branding';

const PromotionSidebar: React.FC = (props) => {
    const [apiMobBanners, setApiMobBanners] = useState([]);
    const history = useHistory();
    useEffect(() => {
        fetchBannerData();
    }, []);

    const fetchBannerData = async () => {
        let webdata = [];
        let mobiledata = [];
        try {
          const response: AuthResponse = await SVLS_API.get(
            `/account/v2/books/${BRAND_DOMAIN}/banners`,
            {
              headers: {
                'Content-Type': 'application/json',
              },
              params: {
                status: 'active',
                type: 'mobile',
                category:'Recommendedbanner'
              },
            }
          );
          let data = response?.data?.banners;
          if(data?.length > 0){
          data.map(item=> {
            if(item.deviceType === "desktop"){
              webdata.push(item);
            }else if(item.deviceType === "mobile"){
              mobiledata.push(item)
            }
          })
          //setApiWebBanners(webdata);
          setApiMobBanners(mobiledata);
        }
        if(mobiledata.length == 0) {
            setApiMobBanners([]);
        } 
        } catch (err) {
          console.log(err)
          if(mobiledata.length == 0) {
            setApiMobBanners([]);
          } 
          //setShowError(true);
          if (err.response && err.response.status === 400) {
            //setErrorText(err.response.data.message);
          } else {
            //setErrorText('Something went wrong');
          }
        }
        
    };

    const navigateToLink = (data) => {
        if(data?.redirectionUrl =='/exchange_sports/inplay' || data?.redirectionUrl =='/casino' || data?.redirectionUrl =='/exchange_sports/cricket' || data?.redirectionUrl =='/exchange_sports/tennis' || data?.redirectionUrl =='/exchange_sports/football'){
          history.push(data?.redirectionUrl);
        }else if(data?.redirectionUrl == 'nourl'){
        }
        else {
          let url = data?.redirectionUrl;
          window.open(url,'_blank');
        }
    };
    return (
        <>
            <div className="promotions-sidebar-ctn web-view">
                <div className="promotions-header">
                    Promotions
                </div>
                {apiMobBanners.length > 0 ? (
                   <div className="promotions-banners">
                    {apiMobBanners.map((banner) => (
                        <div className='banner'>
                            <img
                            src={banner?.publicUrl}
                            key={banner?.title + 'image'}
                            alt={'banner'}
                            onClick={() => {
                                navigateToLink(banner)
                            }}
                            />
                        </div>
                    ))}
                    </div>
                ):(
                    <div className="promotions-banners">
                    <NavLink to={"/exchange_sports/cricket"} className="banner">
                        <img src={Sports} />
                    </NavLink>
                    <div className="banner-divider"></div>
                    <NavLink to="/casino?provider=Royal%20Gaming" className="banner">
                        <img src={RG} />
                    </NavLink>
                    <div className="banner-divider"></div>
                    <NavLink to={"/casino?provider=Ezugi"} className="banner">
                        <img src={Ezugi} />
                    </NavLink>
                    <div className="banner-divider"></div>
                    <NavLink to={"/casino?provider=Evolution%20Gaming"} className="banner">
                        <img src={Evolution} />
                    </NavLink>
                    <div className="banner-divider"></div>
                    <NavLink to={"/casino?provider=Virtual%20Sports"} className="banner">
                        <img src={VSports} />
                    </NavLink>
                     </div>
                )}c
            </div>
        </>
    )
}

export default PromotionSidebar;